import { render, staticRenderFns } from "./FormularioSatisfacao.vue?vue&type=template&id=0ff3c4f3&"
import script from "./FormularioSatisfacao.vue?vue&type=script&lang=js&"
export * from "./FormularioSatisfacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports